import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useAppSelector } from "../../../app/hooks";
import { loginRequest } from "../../../authConfig";
import { LBtn } from "../../../common/components/LBtn";
import { LSubTitle } from "../../../common/components/LSubtitle";
import { LTitle } from "../../../common/components/LTitle";
import { NavItems } from "../../../common/helpers/navigation";
import { AssessmentStatus } from "../../../common/store/generalTypes";
import { useApi } from "../../../services/useApi";
import { Colors } from "../../../styles/colors";
import { AssessmentShell } from "../components/AssessmentShell";
import { Translate } from "react-i18nify";

export const AssessmentComplete = (): JSX.Element => {
    const { instance } = useMsal();
    const { updateAssessmentStatus } = useApi();
    const navigate = useNavigate();
    const assessment = useAppSelector((x) => x.assessment);

    useEffect(() => {
        const completeAssessment = async (): Promise<void> => {
            await updateAssessmentStatus(assessment?.locationId ?? 0, assessment.id ?? 0, AssessmentStatus.Complete);
        };

        void completeAssessment();
    }, []);

    const handleOnFacilitatorLogin = async (): Promise<void> => {
        // TODO: using popup because redirect we lose the assessment id
        await instance.loginPopup({
            ...loginRequest,
            redirectUri: `${location.origin}${NavItems.Assessments.AssessmentReview.path}`
        });

        navigate(NavItems.Assessments.AssessmentReview.path);
    };

    return (
        <div style={{ backgroundColor: Colors.primaryBlue }}>
            <AssessmentShell>
                <div className="is-flex is-flex-direction-column">
                    <LTitle overrideSize="5rem" theme="dark">
                        <Translate value="assessments.completed" />
                    </LTitle>
                    <LSubTitle theme="dark">
                        <Translate value="assessments.thankYou" />
                    </LSubTitle>

                    <div className="is-flex is-justify-content-center mt-6" style={{ textAlign: "start" }}>
                        <LBtn type="button" onClick={handleOnFacilitatorLogin} theme="dark">
                            <Translate value="assessments.facilitatorLogin" />
                        </LBtn>
                    </div>
                </div>
            </AssessmentShell>
        </div>
    );
};
